import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import isBetween from 'dayjs/plugin/isBetween';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import 'dayjs/locale/et';

dayjs.extend(weekday);
dayjs.extend(isBetween);
dayjs.extend(isoWeek);
dayjs.extend(localeData);
dayjs.locale('et');

const DEFAULT_DAYJS_LOCALE = 'et';
const locales = import.meta.glob('/node_modules/dayjs/locale/*.js');

export const loadDayjsLocale = async (code: string): Promise<string> => {
  const candidates = [code, 'en'].filter(
    (candidate) => locales[`/node_modules/dayjs/locale/${candidate}.js`]
  );

  for (const candidate of candidates) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await locales[`/node_modules/dayjs/locale/${candidate}.js`]();
      dayjs.locale(candidate);
      return candidate;
    } catch {
      dayjs.locale(DEFAULT_DAYJS_LOCALE);
    }
  }

  return dayjs.locale();
};

export default dayjs;
